if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        initialSlide: 1,
        slidesPerView: 3,
        effect: 'cards',
        allowTouchMove: false,
        cardsEffect: {
          rotate: false,
          perSlideOffset: 65,
          perSlideRotate: 0,
          slideShadows: false,
        },
        grabCursor: true,
        breakpoints: {
          750: {},
        },
      };
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('hero-slider', HeroSlider);
}
